import { Session$ } from '../../mod/Session$';
import React from 'react';
import { Remote$ } from '../../mod/Remote$';
import { DeviceState$ } from '../../mod/DeviceState$';
import { useRouter } from '@orderx/lab/ui';
import styled from 'styled-components';
import { useDeviceFingerprint } from '../../hooks/device-fingerprint';
import { Iot$ } from '../../mod/Iot$';
import { Idle$ } from '../../mod/Idle$';

export function Global({ children }) {
    return (
        <>
            <State />
            <IotAppEvent />
            <Remote$.Register />
            <Session$.Register />
            {children}
        </>
    );
}

function IotAppEvent() {
    return (
        <Iot$.Subscribe
            topic={`app/event`}
            callback={React.useCallback((event) => {
                const type = event?.type || '';

                if (type === 'reload' && Idle$.isIdle()) {
                    window.location.reload();
                }
            }, [])}
        />
    );
}

function State() {
    const deviceFingerprint = useDeviceFingerprint();
    const router = useRouter();
    const hasInternet = DeviceState$.hasInternet();
    const { url } = DeviceState$.usePersistedUrl();

    React.useEffect(() => {
        Iot$.init(deviceFingerprint.deviceFingerprint);
    }, [deviceFingerprint]);

    deviceFingerprint.useRegister();

    React.useEffect(() => {
        if (url) {
            router.push(url);
        }
    }, [url]);

    return <>{!hasInternet && <Wrapper>We are having trouble reaching the internet</Wrapper>}</>;
}

const Wrapper = styled.div`
    position: fixed;
    z-index: 10000000;
    transition: 200ms;
    background-color: var(--adm-color-danger);
    border-radius: 0;
    transform: translate(0, 0);
    width: 100%;
    height: auto;
    padding: 4px;
    font-size: 10px;
    text-transform: uppercase;
    font-weight: 700;
    text-align: center;
`;
